module.exports = __webpack_public_path__ + "img/gimp.782db698.svg";